'use strict';
/* global document, fetch, location, navigator, window */

// Утилиты
// Поля склеиваются через `~`, а encodeURIComponent тильду не трогает (она
// unreserved по RFC 3986) — экранируем сами, иначе адрес с тильдой разъезжает
// разбор на сервере. Сервер снимает кодирование обратно (services/stats.ts).
const e = (v) => encodeURIComponent(v).replace(/~/g, '%7E');

const h = () => {
  const { host, pathname: path, search, hash } = location;
  return [host, path, search, hash, document.referrer].map(e);
};

// Основная логика
// visitor_id, session_id, hit_id, expire time для сессии
const current =
  document.cookie
    .split(';')
    .find((c) => c.trim().startsWith('_fvsh='))
    ?.split('=')[1]
    ?.split(',') ?? [];

// то, что будет отправлено на сервер
// [0:session_id, 1:hit_id, 2:visitor_id]
const send = [];

if (!current[0]) {
  const visitor = [
    1,
    window.Intl?.DateTimeFormat?.()?.resolvedOptions?.()?.timeZone ?? null,
    new Date().getTimezoneOffset(),
    navigator.language,
  ];
  current[0] = visitor[0];
  send[2] = visitor;
}

if (!(current[1] && Date.now() < current[3])) {
  const session = [1, current[0], ...h()];
  current[1] = session[0];
  send[1] = session;
}

send[0] = [1, current[0], current[1], ...h()];

// Используем IIFE для асинхронного вызова
(async () => {
  try {
    const r = await fetch('/', {
      method: 'PATCH',
      // keepalive: браузер дошлёт запрос, даже если посетитель уже уходит
      // со страницы. Без него теряются самые короткие просмотры.
      keepalive: true,
      body:
        window.lptag +
        '\n' +
        send
          .map((m) =>
            Array.from(m.join('~'))
              .map((char) => char.charCodeAt(0).toString(16).padStart(2, '0'))
              .join('')
          )
          .join('\n'),
    });

    if (!r.ok) return;
    const d = await r.text();
    if (!d) return;

    // сохраняем visitor_id, session_id, hit_id, expire time для сессии.
    //
    // path=/ обязателен: по умолчанию кука привязывается к директории текущей
    // страницы, и на соседнем пути визитор считался бы новым.
    // Domain не указываем — host-only кука не утекает на чужие поддомены.
    // max-age = 400 дней (потолок Chrome), иначе кука сессионная и визитор
    // умирает вместе с окном браузера. Срок жизни самой сессии живёт внутри
    // значения куки (4-е поле), а не в её сроке.
    document.cookie =
      '_fvsh=' +
      d +
      ';path=/;max-age=34560000;samesite=lax' +
      (location.protocol === 'https:' ? ';secure' : '');
  } catch {
    // Аналитика не должна влиять на работу страницы при сетевой ошибке.
  }
})();
